module["exports"] = [
  "#{Address.city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/city.js
// module id = 2636
// module chunks = 2